<mat-accordion>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                <ion-skeleton-text animated style="width: 45%; height: 15px;"></ion-skeleton-text>
            </mat-panel-title>
        </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                <ion-skeleton-text animated style="width: 45%; height: 15px;"></ion-skeleton-text>
            </mat-panel-title>
        </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                <ion-skeleton-text animated style="width: 45%; height: 15px;"></ion-skeleton-text>
            </mat-panel-title>
        </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                <ion-skeleton-text animated style="width: 45%; height: 15px;"></ion-skeleton-text>
            </mat-panel-title>
        </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                <ion-skeleton-text animated style="width: 45%; height: 15px;"></ion-skeleton-text>
            </mat-panel-title>
        </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                <ion-skeleton-text animated style="width: 45%; height: 15px;"></ion-skeleton-text>
            </mat-panel-title>
        </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                <ion-skeleton-text animated style="width: 45%; height: 15px;"></ion-skeleton-text>
            </mat-panel-title>
        </mat-expansion-panel-header>
    </mat-expansion-panel>

</mat-accordion>